export default {
    data() {
        return {
            filters: {
                orderName: undefined,
                search: undefined
            },
            searchTimeout: null
        }
    },
    computed: {
        getSelectedOrder() {
            return {
                desc: '- Z-A',
                asc: '- A-Z',
                default: undefined
            }[this.filters.orderName || 'default']
        }
    },
    methods: {
        setOrderByName(callback) {
            this.filters.orderName = {
                asc: 'desc',
                desc: undefined,
                default: 'asc'
            }[this.filters.orderName || 'default']
            return callback()
        },

        onSearchChange(value, callback) {
            if(this.searchTimeout) clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.filters.search = value.trim()
                callback()
            }, 500)
        }
    }
}